"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isRangeEqual = isRangeEqual;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../Icon");
var _Box = _interopRequireDefault(require("../../Box"));
var _Button = _interopRequireDefault(require("../../Button"));
var _Divider = _interopRequireDefault(require("../../Divider"));
var _Grid = _interopRequireDefault(require("../../Grid"));
var _Wrapper = _interopRequireDefault(require("../Wrapper"));
var _usePickerState2 = _interopRequireDefault(require("../usePickerState"));
var _utils = require("../utils");
var _views = require("../views");
var _RangeSelection = _interopRequireDefault(require("./RangeSelection"));
var _useLimitsDatesValue = _interopRequireDefault(require("./useLimitsDatesValue"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "onChange", "presets", "format", "minDate", "maxDate", "maxRange", "unit", "disablePast", "disableFuture", "shouldDisableDate", "showDaysOutsideCurrentMonth", "view", "placeholder", "checkPresetKey", "checkPresetValue", "fullWidth", "activePreset", "openPeriod", "emptyValue", "disabled", "actions"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function isRangeEqual(rangeA, rangeB) {
  if (rangeA.length === rangeB.length) {
    return rangeA.every(function (d, i) {
      return (0, _utils.isEqual)(d, rangeB[i]);
    });
  }
  return false;
}
var presetsEqual = function presetsEqual(preset, otherPreset) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    checkPresetKey = _ref.checkPresetKey,
    checkPresetValue = _ref.checkPresetValue;
  var equal = true;
  if (equal && checkPresetKey) {
    equal = preset.id === otherPreset.id;
  }
  if (equal && checkPresetValue) {
    equal = isRangeEqual(preset.value, otherPreset.value);
  }
  return equal;
};
var DateRangePicker = function DateRangePicker(_ref2) {
  var _pickerProps$value, _pickerProps$value2;
  var value = _ref2.value,
    onChange = _ref2.onChange,
    _ref2$presets = _ref2.presets,
    presets = _ref2$presets === void 0 ? [] : _ref2$presets,
    format = _ref2.format,
    _ref2$minDate = _ref2.minDate,
    minDate = _ref2$minDate === void 0 ? new Date('1900-01-01') : _ref2$minDate,
    _ref2$maxDate = _ref2.maxDate,
    maxDate = _ref2$maxDate === void 0 ? new Date('2100-01-01') : _ref2$maxDate,
    maxRange = _ref2.maxRange,
    unit = _ref2.unit,
    disablePast = _ref2.disablePast,
    disableFuture = _ref2.disableFuture,
    shouldDisableDate = _ref2.shouldDisableDate,
    showDaysOutsideCurrentMonth = _ref2.showDaysOutsideCurrentMonth,
    view = _ref2.view,
    placeholder = _ref2.placeholder,
    checkPresetKey = _ref2.checkPresetKey,
    checkPresetValue = _ref2.checkPresetValue,
    fullWidth = _ref2.fullWidth,
    activePreset = _ref2.activePreset,
    openPeriod = _ref2.openPeriod,
    emptyValueProp = _ref2.emptyValue,
    disabled = _ref2.disabled,
    actions = _ref2.actions,
    restPropsForTextField = _objectWithoutProperties(_ref2, _excluded);
  var applyRef = React.useRef(null);
  var rangeSelectionRef = React.useRef(null);
  var emptyValue = React.useMemo(function () {
    if (emptyValueProp === undefined) {
      return value;
    }
    return emptyValueProp;
  }, [emptyValueProp, value]);
  var formatOrPresetLabel = function formatOrPresetLabel(value, activePreset) {
    if (!value) {
      return;
    }
    var preset = presets.find(function (preset) {
      return presetsEqual(preset, {
        value: value,
        id: activePreset
      }, {
        checkPresetKey: checkPresetKey,
        checkPresetValue: checkPresetValue
      });
    });
    if (preset) {
      return preset.label;
    }
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return format.apply(void 0, [value].concat(args));
  };
  var _usePickerState = (0, _usePickerState2["default"])({
      value: value,
      onChange: onChange,
      format: formatOrPresetLabel,
      activePreset: activePreset,
      disabled: disabled
    }),
    wrapperProps = _usePickerState.wrapperProps,
    inputProps = _usePickerState.inputProps,
    pickerProps = _usePickerState.pickerProps;
  var fullRange = ((_pickerProps$value = pickerProps.value) === null || _pickerProps$value === void 0 ? void 0 : _pickerProps$value.length) === 2;
  var dirty = (0, _react.useMemo)(function () {
    return value && pickerProps.value ? !isRangeEqual(value, pickerProps.value) : true;
  }, [value, pickerProps.value]);
  var empty = !((_pickerProps$value2 = pickerProps.value) !== null && _pickerProps$value2 !== void 0 && _pickerProps$value2.length);
  var clearable = (0, _react.useMemo)(function () {
    return value && pickerProps.value ? !isRangeEqual(emptyValue, pickerProps.value) : true;
  }, [emptyValue, pickerProps.value]);
  var handleIsPresetSelected = function handleIsPresetSelected(preset) {
    if (pickerProps.value) {
      presetsEqual(preset, {
        value: pickerProps.value,
        id: pickerProps.activePreset
      }, {
        checkPresetKey: checkPresetKey,
        checkPresetValue: checkPresetValue
      });
    }
  };
  var handlePresetSelect = function handlePresetSelect(value, id) {
    pickerProps.onPresetSelect(value, id);
  };
  var handleClear = function handleClear() {
    pickerProps.onChange(emptyValue, false);
    rangeSelectionRef.current.reset(emptyValue);
  };
  var emitChange = function emitChange(v, isFinish) {
    pickerProps.onChange(v, isFinish);
    if (isFinish) {
      applyRef.current.focusVisible();
    }
  };
  var limitsDatesValue = (0, _useLimitsDatesValue["default"])({
    value: pickerProps.value,
    minDate: minDate,
    maxDate: maxDate,
    maxRange: maxRange,
    unit: unit,
    openPeriod: openPeriod
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Wrapper["default"], _objectSpread(_objectSpread({}, wrapperProps), {}, {
    DateInputProps: _objectSpread(_objectSpread(_objectSpread({
      fullWidth: fullWidth,
      placeholder: placeholder,
      disabled: disabled,
      actions: actions
    }, inputProps), restPropsForTextField), {}, {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.DateRangeIcon, {})
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid["default"], {
      container: true,
      "data-cy": 'periodPickerCalendar',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid["default"], {
        item: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_views.PresetList, {
          presets: presets,
          onSelect: handlePresetSelect,
          isSelected: handleIsPresetSelected
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {
        orientation: 'vertical',
        flexItem: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid["default"], {
        item: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeSelection["default"], {
          value: pickerProps.value,
          view: view,
          minDate: minDate,
          maxDate: maxDate,
          minRangeDate: limitsDatesValue.minDate,
          maxRangeDate: limitsDatesValue.maxDate,
          disablePast: disablePast,
          disableFuture: disableFuture,
          shouldDisableDate: shouldDisableDate,
          showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
          openPeriod: openPeriod,
          onChange: emitChange,
          ref: rangeSelectionRef
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box["default"], {
          p: '8px 16px',
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid["default"], {
            container: true,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid["default"], {
              item: true,
              xs: true,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
                disabled: empty || !clearable,
                onClick: handleClear,
                color: 'primary',
                children: "Clear"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid["default"], {
              item: true,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
                onClick: pickerProps.onCancel,
                color: 'primary',
                children: "Cancel"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
                action: applyRef,
                style: {
                  marginLeft: '16px'
                },
                color: 'primary',
                variant: 'outlined',
                onClick: pickerProps.onApply,
                disabled: !fullRange || !dirty,
                children: "Apply"
              })]
            })]
          })
        })]
      })]
    })
  }));
};
DateRangePicker.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _Wrapper["default"].propTypes), _views.PresetList.propTypes), _RangeSelection["default"].propTypes), {}, {
  checkPresetKey: _propTypes["default"].bool,
  checkPresetValue: _propTypes["default"].bool,
  emptyValue: _propTypes["default"].array,
  format: _propTypes["default"].func
});
var _default = exports["default"] = DateRangePicker;